import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { DatasourceTableState } from '@y42/datasource';
import { UiModelingTableStore } from './ui-modeling-table.store';

@Injectable({ providedIn: 'root' })
export class UiModelingTableStoreQuery extends QueryEntity<DatasourceTableState> {
  constructor(protected store: UiModelingTableStore) {
    super(store);
  }
}
